var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikeIconUnliked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_ionic-md-heart-empty",
    "data-name": "Icon ionic-md-heart-empty",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.059,
    height: 24.353,
    viewBox: "0 0 27.059 24.353",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-heart-empty-2",
    "data-name": "Icon ionic-md-heart-empty",
    d: "M22.993,4.5A8.087,8.087,0,0,0,16.9,7.284,8.087,8.087,0,0,0,10.816,4.5a7.265,7.265,0,0,0-7.441,7.3c0,5.042,4.6,9.088,11.565,15.328L16.9,28.853l1.964-1.725c6.966-6.24,11.565-10.287,11.565-15.328A7.265,7.265,0,0,0,22.993,4.5ZM17.737,25.384l-.273.247-.559.495-.559-.495-.273-.247a81.679,81.679,0,0,1-7.981-7.737c-1.821-2.2-2.628-4-2.628-5.847A5.206,5.206,0,0,1,7,8.039a5.364,5.364,0,0,1,3.812-1.509,6.028,6.028,0,0,1,4.495,2.061L16.9,10.436,18.5,8.591a6.006,6.006,0,0,1,4.495-2.061,5.391,5.391,0,0,1,3.818,1.509A5.217,5.217,0,0,1,28.352,11.8c0,1.839-.813,3.647-2.628,5.847A81.848,81.848,0,0,1,17.737,25.384Z",
    transform: "translate(-3.375 -4.5)",
    fill: "#d60000",
    opacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIconUnliked);
export default __webpack_public_path__ + "static/media/like-icon-unliked.512d88dd7e910afad07a9c1306720eee.svg";
export { ForwardRef as ReactComponent };